import Vue from 'vue'
import VueRouter from 'vue-router'
import User from '@/models/User'

Vue.use(VueRouter);

const router = new VueRouter({
    mode: 'history',
    base: process.env.BASE_URL,
    routes: [
        {
            path: '/',
            component: resolve => require(["@/components/protected/Workspace.vue"], resolve),
            children: [
                {
                    path: "",
                    name: "dashboard",
                    component: resolve => require(["@/components/protected/dashboard2/Dashboard2.vue"], resolve)
                },
                {
                    path: "dashboard2",
                    name: "dashboard",
                    component: resolve => require(["@/components/protected/dashboard/Dashboard.vue"], resolve)
                },
                {
                    path: 'marketplace',
                    component: resolve => require(["@/components/protected/marketplace/MarketplaceLayout.vue"], resolve),
                    children: [
                        {
                            path: ':marketplaceid',
                            component: resolve => require(["@/components/protected/marketplace/MarketplaceLayout.vue"], resolve),
                            children: [
                                {
                                    path: 'bills',
                                    component: resolve => require(["@/components/protected/marketplace/bills/BillLayout.vue"], resolve),
                                    children: [
                                        {
                                            path: "",
                                            name: "marketplace-bills",
                                            component: resolve => require(["@/components/protected/marketplace/bills/Bills.vue"], resolve)
                                        },
                                        {
                                            path: "add",
                                            name: "add-marketplace-bill",
                                            component: resolve => require(["@/components/protected/marketplace/bills/NewBill.vue"], resolve)
                                        },
                                        {
                                            path: ":billid",
                                            name: "view-marketplace-bill",
                                            props: true,
                                            component: resolve => require(["@/components/protected/marketplace/bills/actions/View.vue"], resolve)
                                        },
                                        {
                                            path: ":billid/edit",
                                            name: "edit-marketplace-bill",
                                            props: true,
                                            component: resolve => require(["@/components/protected/marketplace/bills/actions/Edit.vue"], resolve)
                                        }
                                    ]
                                },
                                {
                                    path: 'deliverynotes',
                                    component: resolve => require(["@/components/protected/marketplace/deliverynotes/DeliveryNoteLayout.vue"], resolve),
                                    children: [
                                        {
                                            path: "",
                                            name: "deliverynotes",
                                            props: true,
                                            component: resolve => require(["@/components/protected/marketplace/deliverynotes/DeliveryNotes.vue"], resolve)
                                        },
                                        // {
                                        //     path: "",
                                        //     name: "newchallan",
                                        //     component: resolve => require(["@/components/protected/express/challan/actions/New.vue"], resolve)
                                        // },
                                        {
                                            path: ":deliverynoteid",
                                            name: "viewdeliverynote",
                                            props: true,
                                            component: resolve => require(["@/components/protected/marketplace/deliverynotes/action/ViewDeliveryNote.vue"], resolve)
                                        },
                                        {
                                            path: ":deliverynoteid/edit",
                                            name: "editdeliverynote",
                                            props: true,
                                            component: resolve => require(["@/components/protected/express/challan/actions/Edit.vue"], resolve)
                                        },
                                    ]
                                },
                                {
                                    path: 'receipts',
                                    component: resolve => require(["@/components/protected/marketplace/receipts/ReceiptLayout.vue"], resolve),
                                    children: [
                                        {
                                            path: "",
                                            name: "marketplace-receipts",
                                            component: resolve => require(["@/components/protected/marketplace/receipts/Receipts.vue"], resolve)
                                        }
                                    ]
                                },
                                {
                                    path: 'inventory',
                                    component: resolve => require(["@/components/protected/marketplace/inventory1/MarketplaceLayout.vue"], resolve),
                                    children: [
                                        {
                                            path: "",
                                            name: "marketplaceinventory",
                                            props: true,
                                            component: resolve => require(["@/components/protected/marketplace/inventory1/MarketplaceDashboard.vue"], resolve)
                                        },
                                        {
                                            path: "warehouses",
                                            name: "marketplacewarehouses",
                                            component: resolve => require(["@/components/protected/marketplace/inventory1/MarketplaceWarehouses.vue"], resolve)
                                        },
                                        {
                                            path: "warehouses/add",
                                            name: "addmarketplacewarehouse",
                                            component: resolve => require(["@/components/protected/marketplace/inventory1/actions/New.vue"], resolve)
                                        },
                                        {
                                            path: "warehouses/:warehouseid",
                                            name: "viewmarketplacewarehouse",
                                            props: true,
                                            component: resolve => require(["@/components/protected/marketplace/inventory1/actions/View.vue"], resolve)
                                        },
                                        {
                                            path: "warehouses/:warehouseid/edit",
                                            name: "editmarketplacewarehouse",
                                            props: true,
                                            component: resolve => require(["@/components/protected/marketplace/inventory1/actions/Edit.vue"], resolve)
                                        },
                                        {
                                            path: "warehouses/:warehouseid/addcommodity",
                                            name: "add-commodity-to-warehouse",
                                            props: true,
                                            component: resolve => require(["@/components/protected/marketplace/inventory1/actions/pages/AddCommodityToWarehouse"], resolve)
                                        },
                                        {
                                            path: "warehouses/:warehouseid/transfercommodity",
                                            name: "transfer-commodity-from-warehouse",
                                            props: true,
                                            component: resolve => require(["@/components/protected/marketplace/inventory1/actions/pages/TransferCommodityFromWarehouse"], resolve)
                                        },
                                        {
                                            path: "warehouses/:warehouseid/newchallan",
                                            name: "challan-from-warehouse",
                                            props: true,
                                            component: resolve => require(["@/components/protected/marketplace/inventory1/actions/pages/ChallanFromWarehouse"], resolve)
                                        },
                                        {
                                            path: "warehouses/:warehouseid/deductcommodity",
                                            name: "deduct-commodity-from-warehouse",
                                            props: true,
                                            component: resolve => require(["@/components/protected/marketplace/inventory1/actions/pages/DeductCommodityFromWarehouse"], resolve)
                                        },
                                    ]
                                },
                                {
                                    path: 'commodities',
                                    component: resolve => require(["@/components/protected/marketplace/commodities/CommoditiesLayout.vue"], resolve),
                                    children: [
                                        {
                                            path: "",
                                            name: "commodities",
                                            component: resolve => require(["@/components/protected/marketplace/commodities/Commodities.vue"], resolve)
                                        },
                                        {
                                            path: "new",
                                            name: "newcommodity",
                                            component: resolve => require(["@/components/protected/marketplace/commodities/AddCommodity.vue"], resolve)
                                        },
                                        {
                                            path: ":commodityid",
                                            name: "viewcommodity",
                                            props: true,
                                            component: resolve => require(["@/components/protected/marketplace/commodities/ViewCommodity.vue"], resolve)
                                        },
                                        {
                                            path: ":commodityid/edit",
                                            name: "edit-commodity",
                                            props: true,
                                            component: resolve => require(["@/components/protected/marketplace/commodities/EditCommodity.vue"], resolve)
                                        }
                                    ]
                                },
                                {
                                    path: 'warehouses',
                                    component: resolve => require(["@/components/protected/marketplace/warehouses/WarehousesLayout"], resolve),
                                    children: [
                                        {
                                            path: "",
                                            name: "warehouses",
                                            component: resolve => require(["@/components/protected/marketplace/warehouses/Warehouses.vue"], resolve)
                                        },
                                        {
                                            path: "add",
                                            name: "addWarehouse",
                                            component: resolve => require(["@/components/protected/marketplace/warehouses/AddWarehouse.vue"], resolve)
                                        }
                                    ]
                                },

                                {
                                    path: 'marketplacechallans',
                                    component: resolve => require(["@/components/protected/marketplace/challan/MarketplaceChallanLayout.vue"], resolve),
                                    children: [
                                        {
                                            path: "",
                                            name: "marketplacechallans",
                                            props: true,
                                            component: resolve => require(["@/components/protected/marketplace/challan/MarketplaceChallanList.vue"], resolve)
                                        },
                                        {
                                            path: "",
                                            name: "marketplacenewchallan",
                                            component: resolve => require(["@/components/protected/marketplace/challan/actions/MarketplaceChallanNew.vue"], resolve)
                                        },
                                        {
                                            path: ":challanid",
                                            name: "marketplaceviewchallan",
                                            props: true,
                                            component: resolve => require(["@/components/protected/marketplace/challan/actions/MarketplaceChallanView.vue"], resolve)
                                        },
                                        {
                                            path: ":challanid/edit",
                                            name: "marketplaceeditchallan",
                                            props: true,
                                            component: resolve => require(["@/components/protected/marketplace/challan/actions/MarketplaceChallanEdit.vue"], resolve)
                                        },
                                    ]
                                },
                                {
                                    path: 'purchases',
                                    component: resolve => require(["@/components/protected/marketplace/purchases/PurchasesLayout.vue"], resolve),
                                    children: [
                                        {
                                            path: "",
                                            name: "purchases",
                                            component: resolve => require(["@/components/protected/marketplace/purchases/Purchases.vue"], resolve)
                                        },
                                        {
                                            path: "order",
                                            name: "newpo",
                                            component: resolve => require(["@/components/protected/marketplace/purchases/NewPurchaseOrder.vue"], resolve)
                                        },
                                        {
                                            path: "pocheckout",
                                            name: "pocheckout",
                                            props: true,
                                            component: resolve => require(["@/components/protected/marketplace/purchases/PurchaseOrderCheckout.vue"], resolve)
                                        },
                                        {
                                            path: ":poid",
                                            name: "viewpo",
                                            props: true,
                                            component: resolve => require(["@/components/protected/marketplace/purchases/ViewPurchaseOrder.vue"], resolve)
                                        },
                                        {
                                            path: ":poid/edit",
                                            name: "edit-po",
                                            props: true,
                                            component: resolve => require(["@/components/protected/marketplace/purchases/EditPO.vue"], resolve)
                                        }
                                    ]
                                },
                                {
                                    path: 'sales',
                                    component: resolve => require(["@/components/protected/marketplace/sales/SalesLayout.vue"], resolve),
                                    children: [
                                        {
                                            path: "",
                                            name: "sales",
                                            component: resolve => require(["@/components/protected/marketplace/sales/Sales.vue"], resolve)
                                        },
                                        {
                                            path: "order",
                                            name: "newsale",
                                            component: resolve => require(["@/components/protected/marketplace/sales/SaleOrder.vue"], resolve)
                                        },
                                        {
                                            path: ":saleid",
                                            component: resolve => require(["@/components/protected/marketplace/sales/actions/Layout.vue"], resolve),
                                            children: [
                                                {
                                                    path: "",
                                                    name: "viewsale",
                                                    props: true,
                                                    component: resolve => require(["@/components/protected/marketplace/sales/actions/View.vue"], resolve)
                                                },
                                                {
                                                    path: "edit",
                                                    name: "editsale",
                                                    props: true,
                                                    component: resolve => require(["@/components/protected/marketplace/sales/actions/Edit.vue"], resolve)
                                                }
                                            ]
                                        },
                                        {
                                            path: ":saleid/pack",
                                            name: "pack",
                                            props: true,
                                            component: resolve => require(["@/components/protected/marketplace/sales/Fulfillment.vue"], resolve)
                                        }
                                    ]
                                },

                                {
                                    path: 'marketplaceproducts',
                                    component: resolve => require(["@/components/protected/marketplace/label/MarketplaceSKULayout.vue"], resolve),
                                    children: [
                                        {
                                            path: "",
                                            name: "marketplaceproducts",
                                            component: resolve => require(["@/components/protected/marketplace/label/MarketplaceSKUMaster.vue"], resolve)
                                        },
                                        {
                                            path: "label",
                                            name: "marketplacelabel",
                                            component: resolve => require(["@/components/protected/marketplace/label/MarketplaceSKULabel.vue"], resolve)
                                        },
                                        {
                                            path: "add",
                                            name: "marketplaceaddproduct",
                                            component: resolve => require(["@/components/protected/marketplace/label/MarketplaceNewSKU.vue"], resolve)
                                        },
                                        {
                                            path: ":productid",
                                            component: resolve => require(["@/components/protected/marketplace/label/actions/MarketplaceSKUActionLayout.vue"], resolve),
                                            children: [
                                                {
                                                    path: "",
                                                    name: "marketplaceviewproduct",
                                                    props: true,
                                                    component: resolve => require(["@/components/protected/marketplace/label/actions/MarketplaceSKUDisplay.vue"], resolve)
                                                },
                                                {
                                                    path: "edit",
                                                    name: "marketplaceditproduct",
                                                    props: true,
                                                    component: resolve => require(["@/components/protected/marketplace/label/actions/MarketplaceSKUEdit.vue"], resolve)
                                                },
                                                {
                                                    path: "label",
                                                    name: "marketplaceproductlabel",
                                                    props: true,
                                                    component: resolve => require(["@/components/protected/marketplace/label/MarketplaceSKULabel.vue"], resolve)
                                                }
                                            ]
                                        },

                                    ]
                                },
                                {
                                    path: 'invoices',
                                    component: resolve => require(["@/components/protected/marketplace/invoices/MarketplaceInvoiceLayout.vue"], resolve),
                                    children: [
                                        {
                                            path: "",
                                            name: "marketplaceinvoices",
                                            component: resolve => require(["@/components/protected/marketplace/invoices/MarketplaceInvoices.vue"], resolve)
                                        },
                                        {
                                            path: "add",
                                            name: "addmarketplaceinvoice",
                                            component: resolve => require(["@/components/protected/marketplace/invoices/MarketplaceNewInvoice.vue"], resolve)
                                        },
                                        {
                                            path: ":invoiceid",
                                            component: resolve => require(["@/components/protected/marketplace/invoices/actions/Layout.vue"], resolve),
                                            children: [
                                                {
                                                    path: '',
                                                    name: 'viewmarketplaceinvoice',
                                                    component: resolve => require(["@/components/protected/marketplace/invoices/actions/View.vue"], resolve),
                                                    props: true
                                                },
                                                {
                                                    path: 'edit',
                                                    props: true,
                                                    name: 'editmarketplaceinvoice',
                                                    component: resolve => require(["@/components/protected/marketplace/invoices/actions/Edit.vue"], resolve)
                                                }
                                            ]
                                        }
                                    ]
                                },
                                {
                                    path: 'members',
                                    component: resolve => require(["@/components/protected/marketplace/growers/GrowersLayout.vue"], resolve),
                                    children: [
                                        {
                                            path: "",
                                            name: "members",
                                            component: resolve => require(["@/components/protected/marketplace/growers/Members.vue"], resolve),
                                        },
                                        {
                                            path: "list",
                                            name: "growers",
                                            component: resolve => require(["@/components/protected/marketplace/growers/Growers.vue"], resolve),
                                        },
                                        {
                                            path: "add",
                                            name: "addgrower",
                                            component: resolve => require(["@/components/protected/marketplace/growers/AddGrower.vue"], resolve)
                                        },
                                        {
                                            path: "view",
                                            name: "viewgrower",
                                            component: resolve => require(["@/components/protected/marketplace/growers/view.vue"], resolve)
                                        },
                                        {
                                            path: ':catalogid/:memberid',
                                            component: resolve => require(["@/components/protected/marketplace/growers/action/MemberActionLayout"], resolve),
                                            children: [
                                                {
                                                    path: "",
                                                    name: "view-member",
                                                    props: true,
                                                    component: resolve => require(["@/components/protected/marketplace/growers/action/ViewMember.vue"], resolve),
                                                },
                                                {
                                                    path: "card",
                                                    name: "view-member-card",
                                                    props: true,
                                                    component: resolve => require(["@/components/protected/marketplace/growers/action/MemberCard.vue"], resolve),
                                                }
                                            ]
                                        }
                                    ]
                                },
                                {
                                    path: 'reports',
                                    component: resolve => require(["@/components/protected/marketplace/reports/ReportsLayout.vue"], resolve),
                                    children: [
                                        {
                                            path: "purchases",
                                            name: "purchasesreport",
                                            component: resolve => require(["@/components/protected/marketplace/reports/PurchasesReport.vue"], resolve),
                                        },
                                        {
                                            path: "sales",
                                            name: "salesreport",
                                            component: resolve => require(["@/components/protected/marketplace/reports/SalesReport.vue"], resolve)
                                        },
                                        {
                                            path: "invoices",
                                            name: "invoicesreport",
                                            component: resolve => require(["@/components/protected/marketplace/reports/InvoicesReport.vue"], resolve)
                                        },
                                        {
                                            path: 'org/:memberid',
                                            props: true,
                                            component: resolve => require(["@/components/protected/marketplace/reports/summary/Summary.vue"], resolve),
                                            children: [
                                                {
                                                    path: "purchasesummary",
                                                    name: "purchasesummary",
                                                    props: true,
                                                    component: resolve => require(["@/components/protected/marketplace/reports/summary/sections/Purchases.vue"], resolve)
                                                },
                                                {
                                                    path: "salesummary",
                                                    name: "salessummary",
                                                    props: true,
                                                    component: resolve => require(["@/components/protected/marketplace/reports/summary/sections/Sales.vue"], resolve)
                                                },
                                                {
                                                    path: "invoicesummary",
                                                    name: "invoicessummary",
                                                    props: true,
                                                    component: resolve => require(["@/components/protected/marketplace/reports/summary/sections/Invoices.vue"], resolve)
                                                }
                                            ]
                                        },
                                        {
                                            path: "qualities",
                                            component: resolve => require(["@/components/protected/marketplace/reports/qualityreport/QualityReportLayout"], resolve),
                                            children: [
                                                {
                                                    path: "",
                                                    name: "quality-report-list",
                                                    component: resolve => require(["./components/protected/marketplace/reports/qualityreport/QualityReportList"], resolve)
                                                },
                                                {
                                                    path: ":catalogid/:reportid",
                                                    props: true,
                                                    component: resolve => require(["@/components/protected/marketplace/reports/qualityreport/action/QualityReportActionLayout"], resolve),
                                                    children: [
                                                        {
                                                            path: "",
                                                            name: "view-quality-report",
                                                            props: true,
                                                            component: resolve => require(["@/components/protected/marketplace/reports/qualityreport/action/ViewQualityReport"], resolve)
                                                        }
                                                    ]
                                                }
                                            ]
                                        },
                                        {
                                            path: "trace",
                                            component: resolve => require(["@/components/protected/marketplace/reports/tracereport/TraceReportLayout"], resolve),
                                            children: [
                                                {
                                                    path: "",
                                                    name: "trace-report-list",
                                                    component: resolve => require(["./components/protected/marketplace/reports/tracereport/TraceReportList"], resolve)
                                                },
                                            ]
                                        },
                                        {
                                            path: 'org/:memberid',
                                            props: true,
                                            component: resolve => require(["@/components/protected/marketplace/reports/summary/Summary.vue"], resolve),
                                            children: [
                                                {
                                                    path: "purchasesummary",
                                                    name: "purchasesummary",
                                                    props: true,
                                                    component: resolve => require(["@/components/protected/marketplace/reports/summary/sections/Purchases.vue"], resolve)
                                                },
                                                {
                                                    path: "salesummary",
                                                    name: "salessummary",
                                                    props: true,
                                                    component: resolve => require(["@/components/protected/marketplace/reports/summary/sections/Sales.vue"], resolve)
                                                },
                                                {
                                                    path: "invoicesummary",
                                                    name: "invoicessummary",
                                                    props: true,
                                                    component: resolve => require(["@/components/protected/marketplace/reports/summary/sections/Invoices.vue"], resolve)
                                                }
                                            ]
                                        },
                                        {
                                            path: "finance",
                                            component: resolve => require(["@/components/protected/marketplace/reports/financialreport/FinancialReportLayout"], resolve),
                                            children: [
                                                {
                                                    path: '',
                                                    name: 'finance-report-list',
                                                    component: resolve => require(["@/components/protected/marketplace/reports/financialreport/FinancialReportList"], resolve)
                                                },
                                                {
                                                    path: 'new',
                                                    name: 'new-finance-report',
                                                    component: resolve => require(["@/components/protected/marketplace/reports/financialreport/AddFinancialReport"], resolve)
                                                },
                                                {
                                                    path: ":financialreportid",
                                                    props: true,
                                                    component: resolve => require(["@/components/protected/marketplace/reports/financialreport/action/FinancialReportActionLayout"], resolve),
                                                    children: [
                                                        {
                                                            path: "",
                                                            name: "view-finance-report",
                                                            props: true,
                                                            component: resolve => require(["@/components/protected/marketplace/reports/financialreport/action/ViewFinancialReport"], resolve)
                                                        },
                                                        {
                                                            path: "edit",
                                                            name: "edit-finance-report",
                                                            props: true,
                                                            component: resolve => require(["@/components/protected/marketplace/reports/financialreport/action/EditFinancialReport"], resolve)
                                                        }
                                                    ]
                                                }
                                            ]
                                        },
                                        {
                                            path: "attachments",
                                            component: resolve => require(["@/components/protected/marketplace/reports/mycredentials/MyCredentialLayout"], resolve),
                                            children: [
                                                {
                                                    path: '',
                                                    name: 'my-credentials',
                                                    component: resolve => require(["@/components/protected/marketplace/reports/mycredentials/MyCredentialList"], resolve)
                                                },
                                                {
                                                    path: 'new',
                                                    name: 'add-my-credential',
                                                    component: resolve => require(["@/components/protected/marketplace/reports/mycredentials/AddMyCredential"], resolve)
                                                }
                                            ]
                                        }
                                    ]
                                },


                                {
                                    path: "assignment",
                                    name: "assignmentreport",
                                    component: resolve => require(["@/components/protected/marketplace/Assignment/AssignmentReport.vue"], resolve)
                                },

                                {
                                    path: "",
                                    name: "salesassignment",
                                    component: resolve => require(["@/components/protected/marketplace/Assignment/SalesAssignment.vue"], resolve)
                                },


                                {
                                    path: ":assignmentid",
                                    component: resolve => require(["@/components/protected/marketplace/Assignment/Layout.vue"], resolve),
                                    children: [
                                        {
                                            path: '',
                                            name: 'viewassignment',
                                            component: resolve => require(["@/components/protected/marketplace/Assignment/View.vue"], resolve),
                                            props: true
                                        },
                                        {
                                            path: 'edit',
                                            props: true,
                                            name: 'editassignment',
                                            component: resolve => require(["@/components/protected/marketplace/Assignment/Edit.vue"], resolve)
                                        }
                                    ]
                                },

                                {
                                    path: 'offers',
                                    component: resolve => require(["@/components/protected/marketplace/offers/OffersLayout.vue"], resolve),
                                    children: [
                                        {
                                            path: "",
                                            name: "alloffers",
                                            component: resolve => require(["@/components/protected/marketplace/offers/AllOffers.vue"], resolve)
                                        },
                                        {
                                            path: "my",
                                            name: "myoffers",
                                            component: resolve => require(["@/components/protected/marketplace/offers/MyOffers.vue"], resolve)
                                        },
                                        {
                                            path: ":offerid",
                                            name: "viewoffer",
                                            props: true,
                                            component: resolve => require(["@/components/protected/marketplace/offers/ViewOffer.vue"], resolve)
                                        },
                                        {
                                            path: ":offerid",
                                            name: "editoffer",
                                            props: true,
                                            component: resolve => require(["@/components/protected/marketplace/offers/EditOffer.vue"], resolve)
                                        },
                                        {
                                            path: 'new',
                                            component: resolve => require(["@/components/protected/marketplace/offers/new/Wizard.vue"], resolve),
                                            children: [
                                                {
                                                    path: "step1",
                                                    name: "offer_step1",
                                                    component: resolve => require(["@/components/protected/marketplace/offers/new/OfferType.vue"], resolve)
                                                },
                                                {
                                                    path: "step2",
                                                    name: "step2",
                                                    component: resolve => require(["@/components/protected/marketplace/offers/new/CommodityType.vue"], resolve)
                                                },
                                                {
                                                    path: "step3",
                                                    name: "step3",
                                                    component: resolve => require(["@/components/protected/marketplace/offers/new/Movement.vue"], resolve)
                                                },
                                                {
                                                    path: "step4",
                                                    name: "step4",
                                                    component: resolve => require(["@/components/protected/marketplace/offers/new/Pricing.vue"], resolve)
                                                },
                                                {
                                                    path: "step5",
                                                    name: "step5",
                                                    component: resolve => require(["@/components/protected/marketplace/offers/new/Specs.vue"], resolve)
                                                },
                                                {
                                                    path: "summary",
                                                    name: "summary",
                                                    component: resolve => require(["@/components/protected/marketplace/offers/new/Summary.vue"], resolve)
                                                }
                                            ]
                                        }
                                    ]
                                },
                                {
                                    path: 'trades',
                                    component: resolve => require(["@/components/protected/marketplace/trades/TradesLayout.vue"], resolve),
                                    children: [
                                        {
                                            path: "",
                                            name: "mytrades",
                                            component: resolve => require(["@/components/protected/marketplace/trades/MyTrades.vue"], resolve)
                                        },
                                        {
                                            path: 'reports',
                                            component: resolve => require(["@/components/protected/marketplace/trades/reports/TradeReportLayout.vue"], resolve),
                                            children: [
                                                {
                                                    path: "",
                                                    name: "trade-report-list",
                                                    component: resolve => require(["@/components/protected/marketplace/trades/reports/TradeReportList"], resolve)
                                                }
                                            ]
                                        },
                                        {
                                            path: ":tradeid",
                                            name: "viewtrade",
                                            props: true,
                                            component: resolve => require(["@/components/protected/marketplace/trades/ViewTrade.vue"], resolve),
                                        },
                                    ]
                                },

                                {
                                    path: 'contracts',
                                    component: resolve => require(["@/components/protected/marketplace/contracts/MarketplaceContractLayout.vue"], resolve),
                                    children: [
                                        {
                                            path: "",
                                            name: "marketplace-contracts",
                                            component: resolve => require(["@/components/protected/marketplace/contracts/MarketplaceContracts"], resolve)
                                        },
                                        {
                                            path: 'new',
                                            component: resolve => require(["@/components/protected/marketplace/contracts/new/MarketplaceWizard.vue"], resolve),
                                            children: [
                                                {
                                                    path: "step1",
                                                    name: "markrtplacecontractstep1",
                                                    component: resolve => require(["@/components/protected/marketplace/contracts/new/MarketplaceContractProps.vue"], resolve)
                                                },
                                                {
                                                    path: "step2",
                                                    name: "marketplacecontractstep2",
                                                    component: resolve => require(["@/components/protected/marketplace/contracts/new/MarketplaceGoodServices"], resolve)
                                                },
                                                {
                                                    path: "step3",
                                                    name: "marketplacecontractstep3",
                                                    component: resolve => require(["@/components/protected/marketplace/contracts/new/MarketplacePricingTerm.vue"], resolve)
                                                },
                                                {
                                                    path: "step4",
                                                    name: "marketplacecontractstep4",
                                                    component: resolve => require(["@/components/protected/marketplace/contracts/new/MarketplacePaymentTerm.vue"], resolve)
                                                },
                                                {
                                                    path: "step5",
                                                    name: "marketplacecontractstep5",
                                                    component: resolve => require(["@/components/protected/marketplace/contracts/new/MarketplaceAttachment.vue"], resolve)
                                                },
                                                {
                                                    path: "summary",
                                                    name: "marketplacecontractsummary",
                                                    component: resolve => require(["@/components/protected/marketplace/contracts/new/MarketplaceSummary.vue"], resolve)
                                                }
                                            ]
                                        },

                                        {
                                            path: ":contractid",
                                            name: "view-marketplace-contract",
                                            props: true,
                                            component: resolve => require(["@/components/protected/marketplace/contracts/ViewMarketplaceContract.vue"], resolve),
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                },
                {
                    path: 'express',
                    component: resolve => require(["@/components/protected/express/ExpressLayout.vue"], resolve),
                    children: [
                        {
                            path: ':expressid',
                            component: resolve => require(["@/components/protected/express/ExpressLayout.vue"], resolve),
                            children: [
                                {
                                    path: 'inventory',
                                    component: resolve => require(["@/components/protected/express/inventory/Layout.vue"], resolve),
                                    children: [
                                        {
                                            path: "",
                                            name: "expinventory",
                                            props: true,
                                            component: resolve => require(["@/components/protected/express/inventory/Dashboard.vue"], resolve)
                                        },
                                        {
                                            path: "warehouses",
                                            name: "expwarehouses",
                                            component: resolve => require(["@/components/protected/express/inventory/Warehouses.vue"], resolve)
                                        },
                                        {
                                            path: "warehouses/add",
                                            name: "addexpwarehouse",
                                            component: resolve => require(["@/components/protected/express/inventory/actions/New.vue"], resolve)
                                        },
                                        {
                                            path: "warehouses/:warehouseid",
                                            name: "viewexpwarehouse",
                                            props: true,
                                            component: resolve => require(["@/components/protected/express/inventory/actions/View.vue"], resolve)
                                        },
                                        {
                                            path: "warehouses/:warehouseid/edit",
                                            name: "editexpwarehouse",
                                            props: true,
                                            component: resolve => require(["@/components/protected/express/inventory/actions/Edit.vue"], resolve)
                                        },
                                    ]
                                },
                                {
                                    path: 'challans',
                                    component: resolve => require(["@/components/protected/express/challan/Layout.vue"], resolve),
                                    children: [
                                        {
                                            path: "",
                                            name: "challans",
                                            props: true,
                                            component: resolve => require(["@/components/protected/express/challan/List.vue"], resolve)
                                        },
                                        {
                                            path: "",
                                            name: "newchallan",
                                            component: resolve => require(["@/components/protected/express/challan/actions/New.vue"], resolve)
                                        },
                                        {
                                            path: ":challanid",
                                            name: "viewchallan",
                                            props: true,
                                            component: resolve => require(["@/components/protected/express/challan/actions/View.vue"], resolve)
                                        },
                                        {
                                            path: ":challanid/edit",
                                            name: "editchallan",
                                            props: true,
                                            component: resolve => require(["@/components/protected/express/challan/actions/Edit.vue"], resolve)
                                        },
                                    ]
                                },
                                {
                                    path: 'deliverynotes',
                                    component: resolve => require(["@/components/protected/marketplace/deliverynotes/DeliveryNoteLayout.vue"], resolve),
                                    children: [
                                        {
                                            path: "",
                                            name: "deliverynotes",
                                            props: true,
                                            component: resolve => require(["@/components/protected/marketplace/deliverynotes/DeliveryNotes.vue"], resolve)
                                        },
                                        // {
                                        //     path: "",
                                        //     name: "newchallan",
                                        //     component: resolve => require(["@/components/protected/express/challan/actions/New.vue"], resolve)
                                        // },
                                        {
                                            path: ":deliverynoteid",
                                            name: "viewdeliverynote",
                                            props: true,
                                            component: resolve => require(["@/components/protected/express/challan/actions/View.vue"], resolve)
                                        },
                                        {
                                            path: ":deliverynoteid/edit",
                                            name: "editdeliverynote",
                                            props: true,
                                            component: resolve => require(["@/components/protected/express/challan/actions/Edit.vue"], resolve)
                                        },
                                    ]
                                },
                                {
                                    path: 'products',
                                    component: resolve => require(["@/components/protected/express/label/Layout.vue"], resolve),
                                    children: [
                                        {
                                            path: "",
                                            name: "products",
                                            props: true,
                                            component: resolve => require(["@/components/protected/express/label/SKUMaster.vue"], resolve)
                                        },
                                        {
                                            path: "label",
                                            name: "label",
                                            component: resolve => require(["@/components/protected/express/label/Label.vue"], resolve)
                                        },
                                        {
                                            path: "add",
                                            name: "addproduct",
                                            props: true,
                                            component: resolve => require(["@/components/protected/express/label/actions/New.vue"], resolve)
                                        },
                                        {
                                            path: ":productid",
                                            name: "viewproduct",
                                            props: true,
                                            component: resolve => require(["@/components/protected/express/label/actions/Display.vue"], resolve)
                                        },
                                        {
                                            path: ":productid/edit",
                                            name: "editproduct",
                                            props: true,
                                            component: resolve => require(["@/components/protected/express/label/actions/Edit.vue"], resolve)
                                        },
                                        {
                                            path: ":productid/label",
                                            name: "productlabel",
                                            props: true,
                                            component: resolve => require(["@/components/protected/express/label/Label.vue"], resolve)
                                        }
                                    ]
                                },
                                {
                                    path: 'purchases',
                                    component: resolve => require(["@/components/protected/express/purchases/PurchasesLayout.vue"], resolve),
                                    children: [
                                        {
                                            path: "",
                                            name: "expresspurchases",
                                            component: resolve => require(["@/components/protected/express/purchases/Purchases.vue"], resolve)
                                        },
                                        {
                                            path: "add",
                                            name: "addexpresspurchase",
                                            component: resolve => require(["@/components/protected/express/purchases/PurchaseOrder.vue"], resolve)
                                        },
                                        {
                                            path: "checkout",
                                            name: "expresspocheckout",
                                            props: true,
                                            component: resolve => require(["@/components/protected/express/purchases/PurchaseOrderCheckout.vue"], resolve)
                                        },
                                        {
                                            path: "sellers",
                                            component: resolve => require(["@/components/protected/express/purchases/sellers/Layout.vue"], resolve),
                                            children: [
                                                {
                                                    path: "",
                                                    name: "sellers",
                                                    component: resolve => require(["@/components/protected/express/purchases/sellers/Sellers.vue"], resolve)
                                                },
                                                {
                                                    path: "add",
                                                    name: "addseller",
                                                    component: resolve => require(["@/components/protected/express/purchases/sellers/AddSeller.vue"], resolve)
                                                },
                                                {
                                                    path: ":sellerid",
                                                    name: "viewseller",
                                                    props: true,
                                                    component: resolve => require(["@/components/protected/express/purchases/sellers/EditSeller.vue"], resolve)
                                                },
                                                {
                                                    path: ":sellerid/edit",
                                                    name: "editseller",
                                                    props: true,
                                                    component: resolve => require(["@/components/protected/express/purchases/sellers/EditSeller.vue"], resolve)
                                                }
                                            ]
                                        },
                                        {
                                            path: "goods-services",
                                            component: resolve => require(["@/components/protected/express/purchases/goods-services/Layout.vue"], resolve),
                                            children: [
                                                {
                                                    path: "",
                                                    name: "purchasegoodsservices",
                                                    component: resolve => require(["@/components/protected/express/purchases/goods-services/GoodsServices.vue"], resolve)
                                                },
                                                {
                                                    path: "add",
                                                    name: "addpurchasegoodsservices",
                                                    component: resolve => require(["@/components/protected/express/purchases/goods-services/actions/Add.vue"], resolve)
                                                },
                                                {
                                                    path: ':goodsservicesid',
                                                    component: resolve => require(["@/components/protected/express/purchases/goods-services/actions/Layout.vue"], resolve),
                                                    children: [
                                                        {
                                                            path: "view&edit",
                                                            name: "viewpurchasegoodsservices",
                                                            props: true,
                                                            component: resolve => require(["@/components/protected/express/purchases/goods-services/actions/ViewAndEdit.vue"], resolve)
                                                        }
                                                    ]
                                                }
                                            ]
                                        },
                                        {
                                            path: ':poid',
                                            component: resolve => require(["@/components/protected/express/purchases/actions/Layout.vue"], resolve),
                                            children: [
                                                {
                                                    path: "",
                                                    name: "viewexpresspurchase",
                                                    props: true,
                                                    component: resolve => require(["@/components/protected/express/purchases/actions/View.vue"], resolve)
                                                },
                                                {
                                                    path: "edit",
                                                    name: "editexpresspurchase",
                                                    props: true,
                                                    component: resolve => require(["@/components/protected/express/purchases/actions/Edit.vue"], resolve)
                                                }
                                            ]
                                        }
                                    ]
                                },
                                {
                                    path: 'sales',
                                    component: resolve => require(["@/components/protected/express/sales/SalesLayout.vue"], resolve),
                                    children: [
                                        {
                                            path: "buyers",
                                            component: resolve => require(["@/components/protected/express/sales/buyers/Layout.vue"], resolve),
                                            children: [
                                                {
                                                    path: "",
                                                    name: "buyers",
                                                    component: resolve => require(["@/components/protected/express/sales/buyers/Buyers.vue"], resolve)
                                                },
                                                {
                                                    path: "add",
                                                    name: "addbuyer",
                                                    component: resolve => require(["@/components/protected/express/sales/buyers/AddBuyer.vue"], resolve)
                                                },
                                                {
                                                    path: ":buyerid",
                                                    name: "viewbuyer",
                                                    props: true,
                                                    component: resolve => require(["@/components/protected/express/sales/buyers/EditBuyer.vue"], resolve)
                                                },
                                                {
                                                    path: ":buyerid/edit",
                                                    name: "editbuyer",
                                                    props: true,
                                                    component: resolve => require(["@/components/protected/express/sales/buyers/EditBuyer.vue"], resolve)
                                                }
                                            ]
                                        },
                                        {
                                            path: "goods-services",
                                            component: resolve => require(["@/components/protected/express/sales/goods-services/Layout.vue"], resolve),
                                            children: [
                                                {
                                                    path: "",
                                                    name: "salegoodsservices",
                                                    component: resolve => require(["@/components/protected/express/sales/goods-services/GoodsServices.vue"], resolve)
                                                },
                                                {
                                                    path: "add",
                                                    name: "addsalegoodsservices",
                                                    component: resolve => require(["@/components/protected/express/sales/goods-services/Add.vue"], resolve)
                                                },
                                                {
                                                    path: ':goodsservicesid',
                                                    component: resolve => require(["@/components/protected/express/sales/goods-services/actions/Layout.vue"], resolve),
                                                    children: [
                                                        {
                                                            path: "view&edit",
                                                            name: "viewsalegoodsservices",
                                                            props: true,
                                                            component: resolve => require(["@/components/protected/express/sales/goods-services/actions/ViewAndEdit.vue"], resolve)
                                                        }
                                                    ]
                                                }
                                            ]
                                        }
                                    ]
                                },
                                {
                                    path: 'invoices',
                                    component: resolve => require(["@/components/protected/express/invoices/InvoiceLayout.vue"], resolve),
                                    children: [
                                        {
                                            path: "",
                                            name: "expressinvoices",
                                            component: resolve => require(["@/components/protected/express/invoices/Invoices.vue"], resolve)
                                        },
                                        {
                                            path: "add",
                                            name: "addexpressinvoice",
                                            component: resolve => require(["@/components/protected/express/invoices/NewInvoice.vue"], resolve)
                                        },
                                        {
                                            path: ":invoiceid",
                                            component: resolve => require(["@/components/protected/express/invoices/actions/Layout.vue"], resolve),
                                            children: [
                                                {
                                                    path: '',
                                                    name: 'viewexpressinvoice',
                                                    component: resolve => require(["@/components/protected/express/invoices/actions/View.vue"], resolve),
                                                    props: true
                                                },
                                                {
                                                    path: 'edit',
                                                    props: true,
                                                    name: 'editexpressinvoice',
                                                    component: resolve => require(["@/components/protected/express/invoices/actions/Edit.vue"], resolve)
                                                }
                                            ]
                                        }
                                    ]
                                },
                                {
                                    path: 'bills',
                                    component: resolve => require(["@/components/protected/express/bills/BillLayout.vue"], resolve),
                                    children: [
                                        {
                                            path: "",
                                            name: "expressbills",
                                            component: resolve => require(["@/components/protected/express/bills/Bills.vue"], resolve)
                                        },
                                        {
                                            path: "add",
                                            name: "addexpressbill",
                                            component: resolve => require(["@/components/protected/express/bills/NewBill.vue"], resolve)
                                        },
                                        {
                                            path: ":billid",
                                            name: "viewexpressbill",
                                            props: true,
                                            component: resolve => require(["@/components/protected/express/bills/actions/View.vue"], resolve)
                                        }
                                    ]
                                },
                                {
                                    path: 'receipts',
                                    component: resolve => require(["@/components/protected/express/receipts/ReceiptLayout.vue"], resolve),
                                    children: [
                                        {
                                            path: "",
                                            name: "expressreceipts",
                                            component: resolve => require(["@/components/protected/express/receipts/Receipts.vue"], resolve)
                                        }
                                    ]
                                },
                                {
                                    path: 'contracts',
                                    component: resolve => require(["@/components/protected/express/contracts/ContractsLayout.vue"], resolve),
                                    children: [
                                        {
                                            path: "",
                                            name: "contracts",
                                            component: resolve => require(["@/components/protected/express/contracts/Contracts.vue"], resolve)
                                        },
                                        {
                                            path: 'new',
                                            component: resolve => require(["@/components/protected/express/contracts/new/Wizard.vue"], resolve),
                                            children: [
                                                {
                                                    path: "step1",
                                                    name: "newcontractstep1",
                                                    component: resolve => require(["@/components/protected/express/contracts/new/ContractProps.vue"], resolve)
                                                },
                                                {
                                                    path: "step2",
                                                    name: "newcontractstep2",
                                                    component: resolve => require(["@/components/protected/express/contracts/new/GoodsServices.vue"], resolve)
                                                },
                                                {
                                                    path: "step3",
                                                    name: "newcontractstep3",
                                                    component: resolve => require(["@/components/protected/express/contracts/new/PricingTerm.vue"], resolve)
                                                },
                                                {
                                                    path: "step4",
                                                    name: "newcontractstep4",
                                                    component: resolve => require(["@/components/protected/express/contracts/new/PaymentTerm.vue"], resolve)
                                                },
                                                {
                                                    path: "step5",
                                                    name: "newcontractstep5",
                                                    component: resolve => require(["@/components/protected/express/contracts/new/Attachment.vue"], resolve)
                                                },
                                                {
                                                    path: "summary",
                                                    name: "newcontractsummary",
                                                    component: resolve => require(["@/components/protected/express/contracts/new/Summary.vue"], resolve)
                                                }
                                            ]
                                        },
                                        {
                                            path: ":contractid",
                                            name: "viewcontract",
                                            props: true,
                                            component: resolve => require(["@/components/protected/express/contracts/ViewContract.vue"], resolve),
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                },
                {
                    path: 'pricing',
                    component: resolve => require(["@/components/protected/pricing/PricingLayout.vue"], resolve),
                    children: [
                        {
                            path: "",
                            name: "pricediscovery",
                            component: resolve => require(["@/components/protected/pricing/PriceDiscovery.vue"], resolve)
                        },
                        {
                            path: "historicalinfo",
                            name: "historicalinfo",
                            component: resolve => require(["@/components/protected/pricing/HistorialInfo.vue"], resolve)
                        },
                        {
                            path: "tradingview",
                            name: "tradingview",
                            component: resolve => require(["@/components/protected/pricing/TradingView.vue"], resolve)
                        }
                    ]
                },
                {
                    path: "partnerinvitation/:memberid",
                    component: resolve => require(["@/components/protected/marketplace/growers/action/MemberActionLayout"], resolve),
                    children: [
                        {
                            path: "invitation",
                            name: "partner-invitation",
                            props: true,
                            component: resolve => require(["@/components/protected/marketplace/growers/action/ParterIvitationRequest.vue"], resolve),
                        }
                    ]
                },
                {
                    path: 'org',
                    component: resolve => require(["@/components/protected/org/OrgLayout.vue"], resolve),
                    children: [
                        {
                            path: "profile",
                            name: "orgprofile",
                            component: resolve => require(["@/components/protected/org/ViewProfile.vue"], resolve)
                        },
                        {
                            path: "members",
                            name: "orgmembers",
                            component: resolve => require(["@/components/protected/org/Members.vue"], resolve)
                        },
                        {
                            path: "parnershiptype",
                            name: "parnershiptype",
                            component: resolve => require(["@/components/protected/org/express/PartnershipType.vue"], resolve)
                        },
                        {
                            path: "parnershiptype/:partnershipid",
                            name: "viewparnershiptype",
                            props: true,
                            component: resolve => require(["@/components/protected/org/express/ViewPartnershipType.vue"], resolve)
                        },
                        {
                            path: "subscription",
                            name: "orgsubscription",
                            component: resolve => require(["@/components/protected/org/marketplace/Subscription.vue"], resolve)
                        },
                        {
                            path: "invoice",
                            name: "orginvoice",
                            component: resolve => require(["@/components/protected/org/marketplace/Invoice.vue"], resolve)
                        },
                        {
                            path: "taxes",
                            name: "taxes",
                            component: resolve => require(["@/components/protected/org/Taxes.vue"], resolve)
                        },
                        {
                            path: 'settings',
                            component: resolve => require(["@/components/protected/org/settings/Layout.vue"], resolve),
                            children: [
                                {
                                    path: "",
                                    name: "viewsettings",
                                    component: resolve => require(["@/components/protected/org/settings/View.vue"], resolve)
                                },
                                {
                                    path: "edit",
                                    name: "editsettings",
                                    component: resolve => require(["@/components/protected/org/settings/Edit.vue"], resolve)
                                }
                            ]
                        },
                        {
                            path: 'plans',
                            name: 'plans',
                            component: resolve => require(["@/components/protected/org/marketplace/MembershipPlan.vue"], resolve),
                        },
                        {
                            path: 'plans/:planid',
                            name: 'viewplan',
                            props: true,
                            component: resolve => require(["@/components/protected/org/marketplace/ViewMembershipPlan.vue"], resolve),
                        }
                    ]
                },
                {
                    path: "integration",
                    component: resolve => require(["@/components/protected/integration/IntegrationLayout.vue"], resolve),
                    children: [
                        {
                            path: "",
                            name: "integration",
                            component: resolve => require(["@/components/protected/integration/ApiIntegration.vue"], resolve)
                        }
                    ]
                },
                {
                    path: 'myaccount',
                    component: resolve => require(["@/components/protected/myaccount/MyAccountLayout.vue"], resolve),
                    children: [
                        {
                            path: "",
                            name: "viewprofile",
                            component: resolve => require(["@/components/protected/myaccount/ViewProfile.vue"], resolve)
                        },
                        {
                            path: "editprofile",
                            name: "editprofile",
                            component: resolve => require(["@/components/protected/myaccount/EditProfile.vue"], resolve)
                        }
                    ]
                },
                {
                    path: 'banking',
                    component: resolve => require(["@/components/protected/banking/BankingLayout.vue"], resolve),
                    children: [
                        {
                            path: "",
                            name: "accounts",
                            component: resolve => require(["@/components/protected/banking/Accounts.vue"], resolve)
                        },
                        {
                            path: "listaccounts",
                            name: "listaccounts",
                            props: true,
                            component: resolve => require(["@/components/protected/banking/ListAccounts.vue"], resolve),
                        },
                        {
                            path: "transactions/:accountid",
                            name: "transactions",
                            props: true,
                            component: resolve => require(["@/components/protected/banking/Transactions.vue"], resolve)
                        },
                        {
                            path: "wallet",
                            name: "wallet",
                            props: true,
                            component: resolve => require(["@/components/protected/banking/Wallet.vue"], resolve),
                        }
                    ]
                },
                {
                    path: 'mailbox',
                    component: resolve => require(["@/components/protected/mailbox/MailboxLayout.vue"], resolve),
                    children: [
                        {
                            path: "",
                            name: "inbox",
                            component: resolve => require(["@/components/protected/mailbox/Inbox.vue"], resolve)
                        },
                        {
                            path: "sent",
                            name: "sent",
                            component: resolve => require(["@/components/protected/mailbox/Sent.vue"], resolve)
                        },
                        {
                            path: "draft",
                            name: "draft",
                            component: resolve => require(["@/components/protected/mailbox/Draft.vue"], resolve)
                        },
                        {
                            path: "compose",
                            name: "compose",
                            props: true,
                            component: resolve => require(["@/components/protected/mailbox/Compose.vue"], resolve)
                        },
                        {
                            path: ":mailid",
                            name: "mail",
                            props: true,
                            component: resolve => require(["@/components/protected/mailbox/Mail.vue"], resolve),
                        }
                    ]
                },
                {
                    path: 'activities',
                    component: resolve => require(["@/components/protected/activities/ActivitiesLayout.vue"], resolve),
                    children: [
                        {
                            path: "events",
                            name: "events",
                            component: resolve => require(["@/components/protected/activities/Events.vue"], resolve),
                        },
                    ]
                }
            ]
        },
        {
            path: '/auth',
            component: resolve => require(["@/components/auth/AuthLayout.vue"], resolve),
            children: [
                {
                    path: 'login',
                    name: "login",
                    meta: {
                        unsecured: true
                    },
                    component: resolve => require(["@/components/auth/Login.vue"], resolve)
                },
                {
                    path: 'signup',
                    name: "signup",
                    meta: {
                        unsecured: true
                    },
                    component: resolve => require(["@/components/auth/Signup.vue"], resolve)
                },
                {
                    path: 'changepassword',
                    name: "changepassword",
                    meta: {
                        unsecured: true
                    },
                    component: resolve => require(["@/components/auth/ChangePassword.vue"], resolve)
                },
            ]
        }
    ]
});

router.beforeEach((to, from, next) => {
    if (!to.meta.unsecured) {
        let user = User.from(localStorage.token);
        if (user) {
            next()
        } else {
            next({
                name: 'login'
            })
        }
    }
    next()
});

export default router;
